module.exports = "https://trybtryb-legacy.web.app/img/question-mark.10bae576.svg";